import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authFetch } from "../../../api";

export default function TimelineCard() {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const [hasTask, setHasTask] = useState(false);

  const check = async () => {
    try {
      const res = await authFetch("timeline/check-user-assigned-tasks", {
        method: "POST",
        body: JSON.stringify({ user_id: userId }),
        headers: { "Content-Type": "application/json" },
      });
      const data = await res.json();
      setHasTask(data?.data > 0);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    check();
  }, []);
  return (
    <div className="w-full mt-6 ">
      <div className="relative bg-[#9D038508] rounded-xl shadow-md p-6 max-w-[1052px] w-full mx-auto flex items-center border-[1.5px] border-[#FFD2F8]">
        {/* Center Content */}
        <div className="flex flex-col items-center text-center mx-auto max-w-[600px]">
          <h2 className="font-siromi font-bold text-[20px] leading-[100%] text-[#9D0385] mb-2">
            Choose To Get Customized Timeline
          </h2>
          <p
            className="
    font-altis       
    font-normal     
    text-[16px]     
    leading-[100%]   
    tracking-[0px]   
    text-center   
    text-[#333333]   
    max-w-lg mb-4
  "
          >
            Get a personalized roadmap tailored to your goals and aspirations.
            Our experts will create a step-by-step plan for your success.
          </p>

          <button
            onClick={() =>
              navigate(hasTask ? "/sap/customized" : "/sap/select-timeline")
            }
            className="
    bg-[#9D0385] hover:bg-[#9D0385] text-white
    font-altis font-bold text-[14px] leading-[100%] tracking-[0]
    px-6 py-2 rounded-lg transition
    flex items-center gap-2
  "
          >
            Generate Now
            <img
              src="/timeline/Timeline_Profile.svg"
              alt="profile"
              className="w-6 h-6"
            />
          </button>
        </div>

        {/* Right Image */}
        <div className="absolute right-6 top-1/4 -translate-y-1/2 hidden md:block">
          <img
            src="/timeline/OBJECTS.svg"
            alt="Timeline illustration"
            className="max-w-[220px] w-full h-auto"
          />
        </div>
      </div>
    </div>
  );
}
